// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'myLocalMarksFont', 'myLocalMarksFont Fallback'"},"className":"__className_212c10","variable":"__variable_212c10"};